import { Component } from '@angular/core';

@Component({
  selector: 'footer',
  template: require('./footer.component.html')
})
export class FooterComponent {}
